export default "__VITE_ASSET__DIniXT7I__";